import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import * as constants from '../../constants/constants';

const EmptyCart = ({ labelsStore, uiStore }) => {
  const { giftlistSingleFindThem } = labelsStore;
  const messageType = constants.groupLabelMap[uiStore.type].toLowerCase();
  const message = labelsStore[`${messageType}NoProducts`];

  return (
    <>
      <p className="empty-cart__message">{message}</p>
      <p className="empty-cart__guide">{giftlistSingleFindThem}</p>
    </>
  );
};

EmptyCart.propTypes = {
  labelsStore: propTypes.shape({
    giftlistSingleFindThem: propTypes.string,
    allNoProducts: propTypes.string,
    seNoProducts: propTypes.string,
    confNoProducts: propTypes.string
  }).isRequired,
  uiStore: propTypes.shape({
    type: propTypes.string
  }).isRequired
};

export default inject('labelsStore', 'uiStore')(observer(EmptyCart));
